/* Page produit V1 — comportements des sections pdp-* */
(() => {
  if (window.pdpInitialized) return;
  window.pdpInitialized = true;

  /* Galerie produit : miniatures + défilement */
  const initGallery = (root) => {
    root.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-pdp-gallery-track]');
      const thumbs = [...gallery.querySelectorAll('[data-pdp-thumb]')];
      if (!track) return;

      const setActive = (index) => {
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
          setActive(index);
        });
      });

      const prev = gallery.querySelector('[data-pdp-gallery-prev]');
      const next = gallery.querySelector('[data-pdp-gallery-next]');
      const count = track.children.length;
      const currentIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const goTo = (index) => {
        const target = Math.max(0, Math.min(count - 1, index));
        track.scrollTo({ left: track.clientWidth * target, behavior: 'smooth' });
      };

      const updateArrows = () => {
        const index = currentIndex();
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= count - 1;
      };

      prev?.addEventListener('click', () => goTo(currentIndex() - 1));
      next?.addEventListener('click', () => goTo(currentIndex() + 1));

      track.addEventListener(
        'scroll',
        () => {
          setActive(currentIndex());
          updateArrows();
        },
        { passive: true }
      );
      updateArrows();

      /* Glisser à la souris (le tactile utilise déjà le défilement natif) */
      let startX = 0;
      let startScroll = 0;
      let dragging = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      });

      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        const moved = event.clientX - startX;
        const base = Math.round(startScroll / Math.max(track.clientWidth, 1));
        if (Math.abs(moved) > 40) goTo(base + (moved < 0 ? 1 : -1));
        else goTo(base);
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    });
  };

  /* Carrousels (avis, produits) : flèches + points */
  const initTracks = (root) => {
    root.querySelectorAll('[data-pdp-slider]').forEach((slider) => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('.pdp-track');
      const dotsWrap = slider.querySelector('.pdp-track-dots');
      if (!track) return;

      const step = () => {
        const item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      };

      slider.querySelector('[data-pdp-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      slider.querySelector('[data-pdp-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      const renderDots = () => {
        if (!dotsWrap) return;
        const pages = Math.max(1, Math.round(track.scrollWidth / Math.max(track.clientWidth, 1)));
        const current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dotsWrap.innerHTML = '';
        for (let i = 0; i < pages; i += 1) {
          const dot = document.createElement('span');
          if (i === Math.min(current, pages - 1)) dot.classList.add('is-active');
          dotsWrap.appendChild(dot);
        }
      };

      track.addEventListener('scroll', renderDots, { passive: true });
      window.addEventListener('resize', renderDots);
      renderDots();
    });
  };

  /* Sélecteur de quantité */
  const initQuantity = (root) => {
    root.querySelectorAll('[data-pdp-qty]').forEach((qty) => {
      if (qty.dataset.ready) return;
      qty.dataset.ready = 'true';
      const input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const delta = Number(button.dataset.delta || 0);
          input.value = Math.max(1, (Number(input.value) || 1) + delta);
        });
      });
    });
  };

  /* Bandeaux défilants : on duplique la liste pour une boucle continue */
  const initMarquees = (root) => {
    root.querySelectorAll('[data-pdp-marquee]').forEach((viewport) => {
      if (viewport.dataset.ready) return;
      viewport.dataset.ready = 'true';
      const track = viewport.firstElementChild;
      if (!track) return;
      for (let i = 0; i < 2; i += 1) {
        const clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        viewport.appendChild(clone);
      }
    });
  };

  /*
   * Affichage du widget Rapid Bundle façon « prix par carte ».
   * Une unité Shopify = une boîte ; le nombre de cartes vient du titre du palier
   * (« 12 Cards »). Dans chaque palier, on remplace le total par le prix par carte ;
   * sous la grille, un récapitulatif reprend le total du palier choisi, le prix
   * barré et l'économie. Tout est lu dans le widget, donc dans la devise du visiteur.
   */
  const parseMoney = (text) => {
    const match = text.match(/\d[\d.,\s]*/);
    if (!match) return null;
    const raw = match[0].trim();
    const decimal = /[.,]\d{2}$/.test(raw) ? raw.slice(-3, -2) : null;
    const digits = decimal ? raw.slice(0, -3).replace(/[^\d]/g, '') + '.' + raw.slice(-2) : raw.replace(/[^\d]/g, '');
    const value = parseFloat(digits);
    return Number.isFinite(value) ? { value, raw, decimal: decimal || '.' } : null;
  };

  const formatLike = (money, text, value) => {
    const [whole, cents] = value.toFixed(2).split('.');
    const thousands = money.decimal === ',' ? '.' : ',';
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return text.replace(money.raw, `${grouped}${money.decimal}${cents}`);
  };

  const setText = (el, text) => {
    if (el.textContent !== text) el.textContent = text;
  };

  const readTier = (bar) => {
    const title = bar.querySelector('.rapi-bundles__bar-title');
    const priceEl = bar.querySelector('.rapi-bundles__bar-price .money') || bar.querySelector('.rapi-bundles__bar-price');
    const fullEl = bar.querySelector('.rapi-bundles__bar-full-price:not(.rapi-bundles__bar-full-price--ghost)');
    if (!title || !priceEl) return null;
    const cards = parseInt((title.textContent.match(/(\d+)\s*cards?/i) || [])[1], 10);
    const priceText = priceEl.textContent.trim();
    const price = parseMoney(priceText);
    const fullText = fullEl ? fullEl.textContent.trim() : '';
    const full = fullText ? parseMoney(fullText) : null;
    return price ? { cards, priceText, price, fullText, full } : null;
  };

  const updateBundleDisplay = () => {
    document.querySelectorAll('.pdp-buy .rapi-bundles').forEach((widget) => {
      const bars = [...widget.querySelectorAll('.rapi-bundles__bar')];
      const wrapper = widget.closest('.pdp-buy__row > *') || widget;

      // Filet de sécurité : si un seul palier ne se lit pas (Rapid a changé son code,
      // palier renommé sans « N Cards »…), on rend tout l'affichage d'origine de Rapid
      // (totaux visibles, pas de récapitulatif) plutôt que des paliers sans prix.
      const tiers = bars.map(readTier);
      const readable =
        bars.length > 0 &&
        tiers.every((tier, i) => tier && tier.cards > 0 && bars[i].querySelector('.rapi-bundles__bar-content-left'));
      // classList.add/remove modifient l'attribut même sans changement : l'observateur se relançait
      // alors lui-même toutes les 30 ms. On ne touche la classe que si elle doit vraiment changer.
      if (!readable) {
        if (widget.classList.contains('pdp-bundle--per-card')) widget.classList.remove('pdp-bundle--per-card');
        widget.querySelectorAll('.pdp-per-card').forEach((el) => el.remove());
        if (wrapper.nextElementSibling?.classList.contains('pdp-bundle-summary')) wrapper.nextElementSibling.remove();
        return;
      }
      if (!widget.classList.contains('pdp-bundle--per-card')) widget.classList.add('pdp-bundle--per-card');

      bars.forEach((bar, i) => {
        const tier = tiers[i];
        const left = bar.querySelector('.rapi-bundles__bar-content-left');
        let perCard = left.querySelector('.pdp-per-card');
        if (!perCard) {
          perCard = document.createElement('div');
          perCard.className = 'pdp-per-card';
          perCard.innerHTML = '<strong></strong><span>/card</span>';
          left.appendChild(perCard);
        }
        // Arrondi à l'inférieur comme le concurrent : 29,99 / 4 → 7,49 (et non 7,50)
        const perCardValue = Math.floor((tier.price.value / tier.cards) * 100 + 1e-6) / 100;
        setText(perCard.firstElementChild, formatLike(tier.price, tier.priceText, perCardValue));
      });

      // Récapitulatif du palier choisi, juste au-dessus du bouton d'achat
      const selectedIndex = Math.max(0, bars.findIndex((bar) => bar.querySelector('input')?.checked));
      const tier = tiers[selectedIndex];
      let summary = wrapper.nextElementSibling;
      if (!summary || !summary.classList.contains('pdp-bundle-summary')) {
        summary = document.createElement('div');
        summary.className = 'pdp-bundle-summary';
        summary.setAttribute('aria-live', 'polite');
        summary.innerHTML =
          '<span class="pdp-bundle-summary__compare"></span><span class="pdp-bundle-summary__total"></span><span class="pdp-bundle-summary__save"></span>';
        wrapper.after(summary);
      }
      if (!tier) return;
      const [compareEl, totalEl, saveEl] = summary.children;
      const saving = tier.full && tier.full.value > tier.price.value ? tier.full.value - tier.price.value : 0;
      setText(compareEl, saving ? tier.fullText : '');
      setText(totalEl, tier.priceText);
      setText(saveEl, saving ? `You're Saving ${formatLike(tier.price, tier.priceText, saving)}` : '');
      summary.classList.toggle('has-saving', Boolean(saving));
    });
  };

  let bundleTimer = 0;
  const scheduleBundleUpdate = () => {
    clearTimeout(bundleTimer);
    bundleTimer = setTimeout(updateBundleDisplay, 30);
  };

  const initBundleDisplay = () => {
    if (window.pdpBundleObserver) return;
    updateBundleDisplay();
    window.pdpBundleObserver = new MutationObserver(scheduleBundleUpdate);
    // Seule la zone d'achat contient le widget Rapid : observer toute la page coûtait ~370 ms de CPU sur mobile
    window.pdpBundleObserver.observe(document.querySelector('.pdp-buy') || document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    // Un re-clic sur le palier déjà choisi le désélectionnait : on garde la sélection
    document.addEventListener(
      'click',
      (event) => {
        const label = event.target.closest('.pdp-buy .rapi-bundles__bar-container');
        const input = label?.closest('.rapi-bundles__bar')?.querySelector('input');
        if (!input?.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
    document.addEventListener('change', scheduleBundleUpdate, true);
    document.addEventListener('click', scheduleBundleUpdate, true);
  };

  const init = (root = document) => {
    initGallery(root);
    initTracks(root);
    initQuantity(root);
    initMarquees(root);
    initBundleDisplay();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
